import QuotesIcon from '@src/assets/icons/kabes.svg'
import LogoIcon from '@src/assets/icons/logo-icon.svg'
import pageSlugs from '@src/components/layout/pageSlugs'
import { Link } from 'gatsby'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Flex } from 'theme-ui'
import Rating from './Rating'

const feedbackCard = ({ feedback, quoteColor = '#F2F6FF' }) => {
  const { t, i18n } = useTranslation();
  const LinkToTeachersPage = `/${pageSlugs.teacher[i18n.language]}/${
    feedback.tag
  }`;
  return (
    <Box
      className="slide-container"
      sx={{
        height: ['auto', '100%'],
        padding: ['10px 10px 35px', '35px'],
      }}
    >
      <Box
        sx={{
          borderRadius: '20px',
          backgroundColor: 'white',
          padding: ['18px', '28px'],
          boxShadow: '0px 10px 40px #0000001a',
          position: 'relative',
          minHeight: ['180px', '250px'],
          height: '100%',
          display: 'flex',
        }}
      >
        <QuotesIcon
          sx={{
            fill: quoteColor,
            position: 'absolute',
            top: 0,
            right: '50px',
            zIndex: '0',
            maxWidth: ['120px', null, null, '200px'],
            height: 'auto',
          }}
        />
        <Flex
          sx={{
            position: 'relative',
            gap: ['15px', '30px'],
            padding: '28px 0',
            // height: '100%',
          }}
        >
          {feedback.avatar && (
            <Avatar size={['50px', '85px']} src={feedback.avatar} />
          )}

          {!feedback.avatar && (
            <Flex
              bg="primaryPale"
              sx={{
                flexShrink: 0,
                width: '86px',
                height: '86px',
                borderRadius: '50%',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <LogoIcon
                sx={{
                  color: 'white',
                  width: '50px',
                  height: '43px',
                }}
              />
            </Flex>
          )}
          <Box>
            <Box sx={{ marginTop: '-28px', paddingBottom: 3 }}>
              {feedback.rating && <Rating rating={feedback.rating} />}
            </Box>
            <p
              sx={{
                fontSize: ['16px', '18px'],
                marginTop: 0,
                lineHeight: 1.2,
              }}
            >
              {feedback.text}
            </p>
            <p
              sx={{
                fontSize: ['16px', '18px'],
                marginBottom: 0,
                lineHeight: 1.2,
              }}
            >
              {feedback.author.split(' ')[0]}
            </p>
            {feedback.for && feedback.subject && (
              <Link to={LinkToTeachersPage}>
                <p
                  sx={{
                    fontSize: ['16px', '18px'],
                    marginBottom: 0,
                    lineHeight: 1.2,
                    fontStyle: 'italic',
                    cursor: 'pointer',
                    color: 'primary',
                  }}
                >
                  {feedback.subject} - {feedback.for}
                </p>
              </Link>
            )}
          </Box>
        </Flex>

        <Box
          sx={{
            fill: '#fff',
            position: 'absolute',
            top: '100%',
            right: '25px',
          }}
        >
          <svg
            width="55"
            height="30"
            viewBox="0 0 55 30"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M44.5 30C38.5 30 10 8.13559 0 0H55V20.339C55 26.9492 50.5 30 44.5 30Z" />
          </svg>
        </Box>
      </Box>
    </Box>
  );
};

export default feedbackCard;
